<template>
    <div>
<!--        <breadcrumb :routerList="[{to:'/guanhuai',title:'用户交互'},{title:'线索管理'}]" />-->
      <Breadtabsheader/>
        <div class="h-content">
            <!-- 搜素条件 -->
          <div class="h-piece">
            <div class="h-formBox">
              <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
                <div class="h-thirdColumn w-newColumn">
                  <el-form-item label="经销商名称">
                    <el-input v-model="q.customerName1" :clearable="true"></el-input>
                  </el-form-item>
                  <el-form-item label="邮箱">
                    <el-input v-model="q.email" placeholder="请输入邮箱" :clearable="true"></el-input>
                  </el-form-item>
                  <el-form-item label="审批状态">
                    <el-select v-model="q.statusFenxiao" :clearable="true">
                      <el-option label="正常" value="1"></el-option>
                      <el-option label="审批中" value="2"></el-option>
                      <el-option label="驳回" value="3"></el-option>
                      <el-option label="已冻结" value="4"></el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <el-collapse-transition>
                <div v-show="isScreen">
                <div class="h-thirdColumn w-newColumn">
                </div>
                </div>
                </el-collapse-transition>
              </el-form>
              <div class="l-screenBox">
                <div class="l-screen" @click="collapseChange">
                  <img :src="isScreen?closeScreen:drawScreen" alt="">
                  <div class="l-screenText">{{isScreen?"收起":"展开"}}</div>
                </div>
                <div class="l-retrieval">
                  <el-button class="h-btn h-formBtn" @click="query">检索</el-button>
                  <el-button class="h-btn h-formBtn h-bgwhite" @click="rest">重置</el-button>
                </div>
              </div>
            </div>
          </div>
            <!-- 结果展示 -->
            <div class="h-table h-mrt30 smTableRq ljjtablepaddingsrq">
                <!-- @selection-change="handleSelectionChange" -->
                <el-table
                    ref="multipleTable"
                    :data="tableData"
                    @selection-change="handleSelectionChange"
                    :border="true"
                    max-height="560"
                    style="width: 100%"
                >
                <el-table-column
                    type="selection"
                    width="55">
                </el-table-column>
                  <el-table-column
                    label="序号"
                     type="index"
                     width="50px">
                  </el-table-column>
                  <el-table-column prop="customerName1"  label="公司名称" width="200px" ></el-table-column>
<!--                  <el-table-column prop="email" label="公司邮箱" width="150px" ></el-table-column>-->
                  <el-table-column
                          prop="statusFenxiao"
                          label="审批状态"
                          :show-overflow-tooltip="true"
                          align="center"
                          min-width="120">
                    <template slot-scope="scope">
                      <div>
                        <span v-if="scope.row.statusFenxiao == 1">正常</span>
                        <span v-if="scope.row.statusFenxiao == 2">审批中</span>
                        <span v-if="scope.row.statusFenxiao == 3">已驳回</span>
                        <span v-if="scope.row.statusFenxiao == 4">已冻结</span>
                      </div>
                    </template>
                  </el-table-column>

                  <el-table-column
                          prop="signingFenxiao"
                          label="转签约"
                          :show-overflow-tooltip="true"
                          align="center"
                          min-width="120">
                    <template slot-scope="scope">
                      <div>
                        <span v-if="scope.row.signingFenxiao == 0">未转签约</span>
                        <span v-if="scope.row.signingFenxiao == 1">已转签约</span>
                      </div>
                    </template>
                  </el-table-column>
<!--                  <el-table-column-->
<!--                          prop="scale"-->
<!--                          label="客户"-->
<!--                          :show-overflow-tooltip="true"-->
<!--                          align="center"-->
<!--                          min-width="120">-->
<!--                    <template slot-scope="scope">-->
<!--                      <div>-->
<!--                        <span v-if="scope.row.scale == 0">小规模经营者</span>-->
<!--                        <span v-if="scope.row.scale == 1">一般纳税人</span>-->
<!--                      </div>-->
<!--                    </template>-->
<!--                  </el-table-column>-->
                  <el-table-column prop="companyAddress"  label="公司地址" width="120px" show-overflow-tooltip="true"></el-table-column>
<!--                  <el-table-column prop="companytype"  label="公司性质" width="120px" show-overflow-tooltip="true"></el-table-column>-->
                  <el-table-column
                      prop="companytype"
                      min-width="100"
                      :show-overflow-tooltip="true"
                      label="公司性质">
                    <template slot-scope="scope">
                      {{scope.row.companytype | dictname('channel_custagent')}}
                    </template>
                  </el-table-column>
<!--                  <el-table-column-->
<!--                          prop="founded"-->
<!--                          label="成立时间"-->
<!--                          value-format="yyyy-MM-dd"-->
<!--                          :formatter="formatDate"-->
<!--                          width="120px">-->
<!--                    </el-table-column>-->
<!--                  <el-table-column prop="legal" label="总经理姓名" width="120px" ></el-table-column>-->
                  <el-table-column prop="achievement" label="年度营业规模(万元)" width="120px" ></el-table-column>
                  <el-table-column prop="personnelNum" label="销售人员数量" width="80px"></el-table-column>
<!--                  <el-table-column prop="legalPhone" label="总经理联系方式" width="120px" ></el-table-column>-->
                  <el-table-column prop="brand" label="经营其他品牌" width="120px" ></el-table-column>
                  <el-table-column prop="name1" label="联系人姓名" width="120px" ></el-table-column>
                  <el-table-column prop="contactMobilePhone" label="联系人手机号" width="120px" ></el-table-column>
<!--                    <el-table-column prop="country" label="所在国家" width="120px" >-->
<!--                        <template slot-scope="scope">-->
<!--                            <dictname category="YLCountry_agent" :v="scope.row.country"></dictname>-->
<!--                        </template>-->
<!--                    </el-table-column>-->
                    <el-table-column prop="region" label="所在地区" width="120px" >
                    <template slot-scope="scope">
                      <dictname category="YLRegion" :v="scope.row.region"></dictname>
                    </template>
                  </el-table-column>
                  <el-table-column prop="cdate"
                                   label="创建时间"
                                   value-format="yyyy-MM-dd"
                                   width="120px"
                                   :formatter="formatDate"
                  ></el-table-column>
                  <el-table-column label="操作" width="100" fixed="right">
                    <template slot-scope="scope">
                      <div class="w-caozuo" style="text-align: left;">
                        <el-button size="small" class="h-tableLink h-btn" type="text"
                                   @click="shenpi(scope.row.instidFenxiao)"
                                   v-show="scope.row.instidFenxiao">跟踪
                        </el-button>
                      </div>
                    </template>
                  </el-table-column>

                </el-table>
            </div>
        </div>

      <div class="h-tableB h-mrt30">
          <div class="h-tableBL" style="margin-left: 23px">
            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                       @click="freezebatchById">批量冻结
            </el-button>
            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                       @click="thawbatchById">批量解冻
            </el-button>
            <el-button @click="exportExcel" class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import">批量导出</el-button>
           </div>
          <div class="h-pagination2">
            <pagination :page="q" @query="query" style="padding-top: 0.1rem"/>
          </div>
      </div>
      <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>

    </div>
</template>
<script>
import uploaddownexcel from '../../../components/uploaddown/uploaddownexcel'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import agentCopyService from "../../../api/loud/agent/agentCopyService";
import ss from "../../../api/SystemService";
import updownfile from "@/utils/updownfile";
export default {
    components: {
      Treeselect,uploaddownexcel
    },
    data() {
        return {
          // 展开折叠筛选
          isScreen:false,
          closeScreen:require("@/assets/images/pimg/closeallic.png"),
          drawScreen:require("@/assets/images/pimg/dobleArr.png"),
            q:{
              customerName1:'',
              email:'',
              statusFenxiao:'',
              pageSize: 10,
              pageNo: 1,
              total: 0,
            },
            page:{
              pageSize: 10,
              pageNo: 1,
              total: 0,
            },
            size:'',
            tableData:[],
            row:'',   //行
            stVal: null,
            productByNameList: [],
            multipleSelection: [],  //获取选中 表格的集合
            agentList: {ids:[],},
            proSelect: {
              pcode: 0,
              level: 1,
            },
            instid:null,
            showhistory: false,
            disabled: false,
            //批量导入
            uploaddownexcelflag: false,
            yearList:[new Date().getFullYear(),new Date() .getFullYear()+1],
        }
    },
    methods: {
      uploadExcelFilecallback(rd) {
        this.uploaddownexcelflag = false;
        this.query();
        this.$msg.msgs(rd.msg);
        this.clueimport = true;
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
        // 展开折叠
        collapseChange() {
            this.isScreen = !this.isScreen;
        },

      query(){
        this.selectPageAll()
      },
      selectPageAll(){
        agentCopyService.selectFenxiaoListPage(this.q).then(response => {
          this.tableData = response.records;
          this.q.total = response.total;
        })
      },
      shenpi(v) {
        console.log(v, 'instid')
        this.instid = v;
        this.showhistory = true;
      },
      rest(){
        this.q.customerName1='';
        this.q.email='';
        this.q.statusFenxiao='';
      },
      formatDate(row, column) {
        // 获取单元格数据
        let data = row[column.property]
        if(data == null || data == '') {
          return null
        }
        let dt = new Date(data)
        return this.$util.riQi3(dt);
      },
      freezebatchById(){
        if (this.multipleSelection.length == 0 || this.multipleSelection == null){
          this.$message.error("没有选中可以操作的!");
          return false;
        }
        this.multipleSelection.forEach(element => {
          this.agentList.ids.push(element.usercode);
        });
        var data = {
          ids:this.agentList.ids,
        }
        this.$confirm('确定要冻结数据?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          agentCopyService.freezebatchByIdFx(data).then(res => {
            console.log(res)
            if(res.f == true ){
              this.$message({
                type: 'success',
                message: '冻结成功!'
              });
              this.selectPageAll()
            }else{
              this.$message.error(res.msg);
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      },
      thawbatchById(){
        if (this.multipleSelection.length == 0 || this.multipleSelection == null){
          this.$message.error("没有选中可以操作的!");
          return false;
        }
        this.multipleSelection.forEach(element => {
          this.agentList.ids.push(element.usercode);
        });
        var data = {
          ids:this.agentList.ids,
        }
        this.$confirm('确定要解冻数据?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          agentCopyService.thawbatchByIdFx(data).then(res => {
            console.log(res)
            if(res.f == true ){
              this.$message({
                type: 'success',
                message: '解冻成功!'
              });
              this.selectPageAll()
            }else{
              this.$message.error(res.msg);
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      },
      exportExcel() {
        updownfile.down("/api/bscUserInfoAgentBasic/downloadExcel", this.q);
      },
    },
    created(){
      this.selectPageAll();
    },

}
</script>
<style scoped>
    /deep/ .h-formbLine .el-form-item__label{
        width:110px;
    }
    /deep/  .h-formbLine .el-form-item__content{
        width:150px;
    }
    /*/deep/ .h-elformWrap-1 .el-form-item__content{*/
    /*    width: 78%;*/
    /*}*/
    /deep/ .h-elformWrap-1 .el-form-item__content{
      width: 78%;
    }

    .addPro {
      width: 100%;
      /* display:flex; */
    }

    .addPro .el-form-item {
      width: 45% !important;
    }

    .addPro .el-form-item /deep/ .el-form-item__content {
      width: 115px;
    }
    /*设置父级样式*/
    .vue-treeselect >>> .vue-treeselect__control {
      width: 150px;
    }
    .el-switch{
      margin: auto auto auto 20px;
    }
    /*.projectCon p{*/
    /*  justify-content: space-between;*/
    /*  align-items:center;*/
    /*  font-size: 14px;*/
    /*  border-bottom:#1b78e6 1px dashed;*/
    /*  padding: 5px 0;*/
    /*  margin: 0 auto 10px auto;*/
    /*  color: #1b78e6;*/
    /*}*/
</style>
